import React, { useState } from 'react';
import { FaRegCirclePlay, FaRegCircleStop } from 'react-icons/fa6';
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Select,
  Button,
  VStack,
  Text,
  Link,
  CloseButton,
  IconButton,
} from '@chakra-ui/react';
import { usePomodoroSettings } from './PomodoroSettingsContext';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
  const navigate = useNavigate();
  const {
    workDuration,
    breakDuration,
    timerSound,
    setWorkDuration,
    setBreakDuration,
    setTimerSound,
  } = usePomodoroSettings();

  // 入力用のstate（分単位）
  const [workMinutes, setWorkMinutes] = useState(workDuration / 60);
  const [breakMinutes, setBreakMinutes] = useState(breakDuration / 60);
  const [selectedTimerSound, setSelectedTimerSound] = useState(timerSound);

  // 再生管理
  const [audio, setAudio] = useState<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleSave = () => {
    setWorkDuration(workMinutes * 60);
    setBreakDuration(breakMinutes * 60);
    setTimerSound(selectedTimerSound);
    navigate('/');
  };

  const playSound = (name: string) => {
    // 再生中なら停止
    if (audio && isPlaying) {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
      return;
    }

    let fileName = '';
    switch (name) {
      case 'School Bell':
        fileName = '../sounds/Japanese_School_Bell04-1(Long).mp3';
        break;
      case 'Church Bell':
        fileName = '../sounds/Church_Bell03-09(Low-Long).mp3';
        break;
      case 'Temple Bell':
        fileName = '../sounds/Bonsho03-1(High).mp3';
        break;
      default:
        fileName = '../sounds/Japanese_School_Bell04-1(Long).mp3';
    }

    const newAudio = new Audio(fileName);
    setAudio(newAudio);
    newAudio.play();
    setIsPlaying(true);

    newAudio.onended = () => {
      setIsPlaying(false);
    };
  };

  return (
    <Box
      position={'relative'}
      maxW="400px"
      maxH={'95vh'}
      mx="auto"
      mt={6}
      p={6}
      bg="yellow.50"
      borderRadius="xl"
      boxShadow="md"
      color="gray.700"
      zIndex={99}
      className="Settings"
      overflowY="auto"
    >
      <CloseButton
        aria-label="Close"
        size="lg"
        position="absolute"
        top={4}
        right={4}
        cursor="pointer"
        onClick={() => navigate('/')}
        variant="ghost"
      />

      <Heading textAlign="center" size="md" mb={6} mt={50}>
        タイマー設定
      </Heading>

      <VStack spacing={5} align="stretch">
        <FormControl>
          <FormLabel>作業時間 (分)</FormLabel>
          <Select
            value={workMinutes}
            onChange={(e) => setWorkMinutes(Number(e.target.value))}
          >
            {[...Array(60)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>休憩時間 (分)</FormLabel>
          <Select
            value={breakMinutes}
            onChange={(e) => setBreakMinutes(Number(e.target.value))}
          >
            {[...Array(30)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel>タイマー音</FormLabel>
          <Select
            value={selectedTimerSound}
            onChange={(e) => setSelectedTimerSound(e.target.value)}
          >
            <option>学校のチャイム</option>
            <option>教会の鐘</option>
            <option>寺の鐘</option>
          </Select>
          <Text fontSize="xs" mt={1}>
            <Link href="https://otologic.jp" isExternal color="gray.500">
              OtoLogicの音源を使用しています
            </Link>
          </Text>
          <Box display={'flex'} justifyContent="right">
            <IconButton
              aria-label={isPlaying ? 'Stop' : 'Play'}
              icon={
                isPlaying ? (
                  <FaRegCircleStop size={32} />
                ) : (
                  <FaRegCirclePlay size={32} />
                )
              }
              // variant="ghost"
              colorScheme="gray"
              size="md"
              onClick={() => playSound(selectedTimerSound)}
            />
          </Box>
        </FormControl>

        <Button colorScheme="teal" mt={4} onClick={handleSave}>
          保存
        </Button>
      </VStack>
    </Box>
  );
};

export default Settings;
